/*
* Association amenity responsibilities form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsAmenityResponsibilitiesExteriorCheckboxes = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    const inputPropsCheckbox = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 7,
        colInputXs: 5,
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <Row>
                <Col xs={4}>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.trashEnclosures"
                            label={appText('trash-enclosures')}
                            value={formData.details.trashEnclosures}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.monumentSigns"
                            label={appText('monument-signs')}
                            value={formData.details.monumentSigns}
                            {...inputPropsCheckbox}
                        />
                    </div>

                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.bikeWalkingPaths"
                            label={appText('bike-walking-paths')}
                            value={formData.details.bikeWalkingPaths}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.streetLighting"
                            label={appText('street-lighting')}
                            value={formData.details.streetLighting}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.streetSigns"
                            label={appText('street-signs')}
                            value={formData.details.streetSigns}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.outdoorFurniture"
                            label={appText('outdoor-furniture')}
                            value={formData.details.outdoorFurniture}
                            {...inputPropsCheckbox}
                        />
                    </div>
                </Col>
                <Col xs={4}>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.awnings"
                            label={appText('awnings')}
                            value={formData.details.awnings}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.mailboxes"
                            label={appText('mailboxes')}
                            value={formData.details.mailboxes}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.walkways"
                            label={appText('walkways')}
                            value={formData.details.walkways}
                            {...inputPropsCheckbox}
                        />
                    </div>
                      <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.fireEscapes"
                            label={appText('fire-escapes')}
                            value={formData.details.fireEscapes}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.buildingLighting"
                            label={appText('building-lighting')}
                            value={formData.details.buildingLighting}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.decksBalconies"
                            label={appText('decks-balconies')}
                            value={formData.details.decksBalconies}
                            {...inputPropsCheckbox}
                        />
                    </div>
                </Col>
                <Col xs={4}>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.carports"
                            label={appText('carports')}
                            value={formData.details.carports}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.garages"
                            label={appText('garages')}
                            value={formData.details.garages}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.exteriorStairways"
                            label={appText('exterior-stairways')}
                            value={formData.details.exteriorStairways}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.waterscapesFountains"
                            label={appText('waterscapes-fountains')}
                            value={formData.details.waterscapesFountains}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.playgroundEquipment"
                            label={appText('playground-equipment')}
                            value={formData.details.playgroundEquipment}
                            {...inputPropsCheckbox}
                        />
                    </div>
                    <div>
                        <KendoWrappers.KendoCheckbox
                            name="details.gazebos"
                            label={appText('gazebos')}
                            value={formData.details.gazebos}
                            {...inputPropsCheckbox}
                        />
                    </div>
                </Col>
            </Row>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-amenity-responsibilities-exterior-checkboxes.tsx